"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnClickPrefetcher = exports.OnHoverPrefetcher = exports.OnRenderPrefetcher = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefetcher = _interopRequireDefault(require("./prefetcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = _prefetcher["default"];
exports["default"] = _default;

var OnRenderPrefetcher = function OnRenderPrefetcher(_ref) {
  var link = _ref.link,
      other = _objectWithoutProperties(_ref, ["link"]);

  return _react["default"].createElement(_prefetcher["default"], _extends({
    onRenderAssets: link
  }, other));
};

exports.OnRenderPrefetcher = OnRenderPrefetcher;

var OnHoverPrefetcher = function OnHoverPrefetcher(_ref2) {
  var link = _ref2.link,
      other = _objectWithoutProperties(_ref2, ["link"]);

  return _react["default"].createElement(_prefetcher["default"], _extends({
    onHoverAssets: link
  }, other));
};

exports.OnHoverPrefetcher = OnHoverPrefetcher;

var OnClickPrefetcher = function OnClickPrefetcher(_ref3) {
  var link = _ref3.link,
      other = _objectWithoutProperties(_ref3, ["link"]);

  return _react["default"].createElement(_prefetcher["default"], _extends({
    onClickAssets: link
  }, other));
};

exports.OnClickPrefetcher = OnClickPrefetcher;